import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import Business from "static/icons/business_black_24dp.svg"

const ModuleCompanyIcon = (props: IconWrapperIconProps) => {
  const name = "moduleCompany"
  return (
    <IconWrapper name={name} {...props}>
      <Business/>
    </IconWrapper>
  )
}
export default ModuleCompanyIcon
